import React, { useState, useEffect } from 'react';
import { Button, ButtonGroup, Card, CardBody, Row, Col, Label, Input } from 'reactstrap';
import ErrorBoundary from "components/ErrorBoundary";
import { dateFormate, cellRendererCheck, currencyFormat } from "utils/columns";
import useAxios from 'hooks/useAxios';
import Confirm from "components/Confirm";
import save from "assets/icon/save.svg";
import { ModuleAccess } from 'utils/moduleaccess';
import { toast } from 'react-toastify';
import Cancel from "src/assets/icon/cancel.svg";
import EditIcon from "assets/icon/edit.svg"



import { onExport, getUpdatedFilter } from 'utils/helper';
import OrderDetailsTable from './OrderDetailsTable'
import useContextService from 'hooks/useContextService';
import { cloneDeep } from 'lodash';

let initialFilters = {
  currentPage: 1,
  pageSize: 10,
  orderBy: '',
  order: '',
  filters: [],
};
let updatedData = [];
let thirdPartyAdminDetails = {};
let qtyValueChanged = false;

const OrderDetailsDrawer = ({ toggle, tenantID, rowData, onRefetch, accountype, Non340BTenantID, cpId,
  setAccountype }) => {
  const API = useAxios();
  const [tempData, setTempData] = useState([]);
  const [isConfirm, setConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const [savebtnDisabled, setSaveBtnDisabled] = useState(false);
  const [isVisibleSubmitEdit, setIsVisibleSubmitEdit] = useState(false);
  const [isVisibleSaveCancel, setIsVisibleSaveCancel] = useState(false);
  const [qtyOrdCheck, setQtyOrdCheck] = useState(false);
  const [handleCancelChange, setHandleCancelChange] = useState(false)
  const [columnFilters, setColumnFilters] = useState([]);
  const {
    states: { purchaseOrder },
    setStates,
  } = useContextService();
  const { search, thirdPartyAdmin, coveredEntity, searchTerms } = purchaseOrder;


  const [state, updateState] = useState({
    data: [],
    loading: false,
    records: 0,
    reset: false,
  });
  const setState = (obj) => updateState((pre) => ({ ...pre, ...obj }));
  const [colFilter, setColFilter] = useState([]);


  const hasPermission = (code) => {
    return ModuleAccess("PO", code);
  };


  useEffect(() => {
    initialFilters = {
      currentPage: 1,
      pageSize: 10,
      orderBy: '',
      order: '',
      filters: [],
    };
    updatedData = [];
    setState({ data: [], records: 0 });
    if (rowData) {
      const { poid } = rowData;
      if (poid) {
        initialFilters.filters = getUpdatedFilter(
          'poid',
          poid,
          initialFilters
        );
      }
      initialFilters.currentPage = 1;
      if (accountype == 1) { fetchPOOrderDetails(initialFilters); }

      else if (accountype == 2) { fetchNon340BPOOrderDetails(initialFilters) }
    }

  }, []);

  const fetchNon340BPOOrderDetails = async (pageDetails = {}, hasColumnFilter) => {
    setState({ loading: true });
    let filter = { ...pageDetails };
    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      filter.pageSize = 0;
      filter.currentPage = 1;
      //initialFilters.filters = [...filter.filters];
    } else {
      initialFilters = { ...initialFilters, ...filter };
      filter.pageSize = 0;
      filter.currentPage = 1;
    }
    try {
      const { data } = await API.post(
        `/${Non340BTenantID}/PurchaseOrder/Non340BPODetails/${cpId}`, filter
      );
      if (data) {
        setState({
          data: data.items,
          records: data.totalRecords,
          loading: false,
        });
        setTempData(data.items);
      } else {
        setState({
          data: [],
          records: 0,
          loading: false,
        });
      }
    } catch (error) {
      setState({ loading: false, data: [] });
    }
  };
  
  const fetchPOOrderDetails = async (pageDetails = {}, hasColumnFilter) => {
    setState({ loading: true });
    let filter = { ...pageDetails };
    if (hasColumnFilter) {
      filter.filters = [...initialFilters.filters, ...pageDetails.filters];
      filter.pageSize = 0;
      filter.currentPage = 1;
      //initialFilters.filters = [...filter.filters];
    } else {
      initialFilters = { ...initialFilters, ...filter };
      filter.pageSize = 0;
      filter.currentPage = 1;
    }
    setColumnFilters(filter);
    try {
      const { data } = await API.post(
        `/${tenantID}/PurchaseOrder/AllPODetails`, filter
      );
      if (data) {
        setState({
          data: data.items,
          records: data.totalRecords,
          loading: false,
        });
        setTempData(data.items);
      } else {
        setState({
          data: [],
          records: 0,
          loading: false,
        });
      }
    } catch (error) {
      setState({ loading: false, data: [] });
    }
  };

  const handleExport = async () => {
    const filterObj = cloneDeep(search);
    if (rowData) {
      const { poid } = rowData;
      if (poid) {
        initialFilters.filters = getUpdatedFilter(
          'poid',
          poid,
          initialFilters
        );
      }
    }
    if (initialFilters.filters.length > 0 || colFilter || colFilter.length > 0) {
      filterObj.filters = [
      ...(colFilter.filters || []),
      ...(initialFilters.filters || [])];
    }

    filterObj.orderBy = "";
    filterObj.order = "";
    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID || 0;
    var payload = {};
    payload.tenantID = tenantID;
    payload.gridCode = "PODetails";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };

  const handleNon340BDetailsExport = async () => {
    const filterObj = cloneDeep(search);
    if (rowData) {
      const { poid } = rowData;
      if (poid) {
        initialFilters.filters = getUpdatedFilter(
          'poid',
          poid,
          initialFilters
        );
        
      }
    }
    if (initialFilters.filters.length > 0 || colFilter || colFilter.length > 0) {
      filterObj.filters = [
      ...(colFilter.filters || []),
      ...(initialFilters.filters || [])];
    }

    filterObj.orderBy = "";
    filterObj.order = "";
    var additionalCriteria = {};
    additionalCriteria.IsSelectedColumn = false;
    filterObj.ThirdPartyAdminID = searchTerms.thirdPartyAdminID || 0;
    filterObj.chainPharmacyID = [searchTerms.chainPharmacyID] || [0];
    var payload = {};
    payload.tenantID = Non340BTenantID;
    payload.gridCode = "Non340BPODetails";
    payload.fileTypeCode = "csv";
    payload.criteria = JSON.stringify(filterObj);
    payload.additionalCriteria = JSON.stringify(additionalCriteria);
    const { data } = await API.post(`export/queue`, payload, {
      hasExport: true,
    });
  };


  const onPageChange = (filter, hasFilter) => {
    if (hasFilter) {
      if (accountype == 1) {
        fetchPOOrderDetails(filter, true);
      } else if (accountype == 2) {
        fetchNon340BPOOrderDetails(filter, true);
      }
    } else {
      if (accountype == 1) {
        fetchPOOrderDetails(filter);
      } else if (accountype == 2) {
        fetchNon340BPOOrderDetails(filter);
      }
    }
  };

  const handleSearchColumnFilters = async (columnFilters) => {
    setColFilter(columnFilters);
    if (accountype == 1 || accountype == "1") {
      await fetchPOOrderDetails({ ...initialFilters, ...columnFilters }, true);
    } else if (accountype == 2 || accountype == "2") {
      await fetchNon340BPOOrderDetails({ ...initialFilters, ...columnFilters }, true);
    }
  };

  const refetch = (hasReset) => {
    if (hasReset) {
      setColFilter([]);
      initialFilters = {
        ...initialFilters,
        currentPage: 1,
      };
    }
    if (accountype == 1 || accountype == "1") {
      fetchPOOrderDetails(initialFilters);
    } else if (accountype == 2 || accountype == "2") {
      fetchNon340BPOOrderDetails(initialFilters);
    }
  };

  const handleSaveButton = (val) => {
    setSaveBtnDisabled(val);
  }

  const hcandleQtyChange = (rowData, val) => {
    if (val == true) {
      qtyValueChanged = true;
      if (updatedData.length == 0) {
        updatedData.push(rowData)
      } else {
        for (var x in updatedData) {
          if (updatedData[x].poItemID == rowData.poItemID) {
            updatedData[x].packageOrdered = rowData.packageOrdered;
          } else {
            updatedData.push(rowData);
          }

        }
      }
    }
    setTempData(tempData);

  };

  const handleSavePOItems = async () => {
    setLoading(true);
    let payload = {};
    payload.tempData = [];
    if (qtyValueChanged == true) {
      const arry = updatedData.reduce((acc, current) => {
        const exists = acc.find(item => item.poItemID === current.poItemID);
        if (!exists) {
          acc.push(current);
        }
        return acc;
      }, []);


      for (var x in tempData) {
        for (var y in arry) {
          if (tempData[x].poItemID == arry[y].poItemID) {
            tempData[x].packageOrdered = arry[y].packageOrdered;
            tempData[x].poItemEditAction = arry[y].poItemEditAction;
          }
        }
        payload.tempData.push(tempData[x]);
      }
    }
    else {
      for (var x in tempData) {
        payload.tempData.push(tempData[x]);
      }
    }
    try {
      const result = await API.post(
        `/${tenantID}/PurchaseOrder/savepoitems`,
        payload
      );
      if (result) {
        if (result.data.error) {
          toast.error(result.data.message);
        } else {
          toggle();
          toast.success("Items updated successfully");
          onRefetch();
          //fetchPOOrderDetails(initialFilters);

          setLoading(false);
        }
      }
    } catch (error) {

      setLoading(false);
    }
    setLoading(false);
    setConfirm(!isConfirm);
  };


  const handleSaveConfirmations = () => {
    setConfirm(!isConfirm);
  };



  const handleSubmitSave = () => {
    handleSaveConfirmations();
    if (!isConfirm) return null;
    else {
      handleSavePOItems();
    }
  };


  const SubmitButton = () => {
    return (<>
      <Button color='primary' className='search' size='sm' disabled={savebtnDisabled} onClick={() => { console.log("submit is working..."), handleSubmitSave() }}>
        <span className="right_5">
          <img src={save} alt="" />
        </span>{" "}
        submit</Button>

    </>)
  }
  const EditButton = () => {
    return (
      <Button color='primary' className="reset" size='sm' onClick={() => { setHandleCancelChange(!handleCancelChange), handleIsVisible(), handlesetQtyOrdCheck() }} >

        <span className="right_5">
          <img src={EditIcon} alt="" />
        </span>{" "}
        Edit</Button>

    )
  }
  const CancelButton = () => {
    return (
      <Button color='primary' className='reset' size='sm' onClick={() => {
        setHandleCancelChange(!handleCancelChange), handleIsVisible(), handlesetQtyOrdCheck(),
          refetch();
      }}>
        <span className="right_5">
          <img src={Cancel} alt="" />
        </span>{" "}

        Cancel</Button>
    )
  }
  // console.log(setState,"update")
  const handleIsVisible = () => {
    setIsVisibleSaveCancel(!isVisibleSaveCancel),
      setIsVisibleSubmitEdit(!isVisibleSubmitEdit)
  }

  const handlesetQtyOrdCheck = () => {
    setQtyOrdCheck(!qtyOrdCheck),
      setSaveBtnDisabled(false)
  }

  return (
    <div>
      <Card >
        <CardBody>
          <Col xs="auto">
            <Row>
              <Col md='2'>
                <p className="m-0 f-14 float-end">PO# :</p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 font-weight-500">{rowData?.poid || ''}</p>
              </Col>

              <Col>
                <p className="m-0 f-14 float-end">PO Date :</p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 font-weight-500">{dateFormate(rowData?.poDate) || ''}</p>
              </Col>

              <Col>
                <p className="m-0 f-14 float-end">PO Status :</p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 font-weight-500">{rowData?.poStatus || ''}</p>
              </Col>
            </Row>
            <Row className='mt-4'>
              {accountype == 1 ?
                <>
                  <Col md="2">
                    <p className="m-0 f-14 float-end">Covered Entity :</p>
                  </Col>
                  <Col md="2">
                    <p className="m-0 f-14 font-weight-500">{rowData?.coveredEntityName || ''}</p>
                  </Col>
                </> : <>
                  <Col md="2">
                    <p className="m-0 f-14 float-end">Chain Pharmacy :</p>
                  </Col>
                  <Col md="2">
                    <p className="m-0 f-14 font-weight-500">{"Chain Pharmacy" || ''}</p>
                  </Col>
                </>}

              <Col>
                <p className="m-0 f-14 float-end">Pharmacy :</p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 font-weight-500">{rowData?.pharmacyName || ''}</p>
              </Col>
              <Col md={2}>
                <p className="m-0 f-14 float-end">Wholesaler :</p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 font-weight-500">{rowData?.wholesaler || ''}</p>
              </Col>
            </Row>
            <Row className='mt-4'>
              <Col md={2}>
                <p className="m-0 f-14 float-end">Total Ordered Price :</p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 font-weight-500">{currencyFormat(rowData?.poPackageCost) || ''}</p>
              </Col>
              <Col md={2}>
                <p className="m-0 f-14 float-end">Total Invoiced Price :</p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 font-weight-500">{currencyFormat(rowData?.totalInvoicedPrice) || ''}</p>
              </Col>
              <Col md={2}>
                <p className="m-0 f-14 float-end">Account Type :</p>
              </Col>
              <Col md="2">
                <p className="m-0 f-14 font-weight-500">{rowData?.accountType || ''}</p>
              </Col>
            </Row>
          </Col>
        </CardBody>
        <CardBody className='border-top'>
          <ErrorBoundary>
            <OrderDetailsTable
              data={state.data}
              loading={state.loading}
              onExport={(accountype == 1) ? handleExport : handleNon340BDetailsExport}
              filters={initialFilters}
              totalSize={state.records}
              onPageChange={onPageChange}
              setLoading={(value) => setState({ loading: value })}
              refetch={refetch}
              onSearchColumnFilters={handleSearchColumnFilters}
              reset={state.reset}
              onQtyChange={hcandleQtyChange}
              handleSaveButton={handleSaveButton}
              qtyOrdCheck={qtyOrdCheck}
              handleCancelChange={handleCancelChange}
              accountype={accountype}
            />
          </ErrorBoundary>


          {rowData.poStatusID == 5010 && hasPermission("PODC") && (accountype == 1) ?

            <div className='orderDetailsTableButtons'>
              <div>              <p className='note'>[Note] : A - Authorized and C - Cancelled. Once order items are Authorized/Cancelled, cannot be reverted.</p>
              </div>
              <div className='d-flex'>
                {!isVisibleSubmitEdit &&
                  <> <EditButton /> </>
                }
                {isVisibleSaveCancel &&
                  <> <CancelButton /></>
                }

                <SubmitButton />
              </div>
            </div>

            : null}



        </CardBody>

        <Confirm
          isOpen={isConfirm}
          loading={loading}
          message="Are you sure you want to submit this purchase order?"
          onToggle={handleSaveConfirmations}
          onCancel={handleSaveConfirmations}
          onContinue={handleSavePOItems}
        />
      </Card>

    </div>
  );
};

export default OrderDetailsDrawer;
